import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=1fdf4948&scoped=true&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=ts&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf4948",
  null
  
)

export default component.exports